import NotFoundPage from "@/views/NotFoundPage";

import Vue from 'vue'
import VueRouter from 'vue-router'

import DashboardPage from  "@/views/Dashboard"
import HrPage from  "@/views/HR/HRPersonelManagement"
import HrPassport from "@/views/HR/HRPersonelPassportReport"

import DailyCrewSchedulePage from  "@/views/Dai_Gendec/DailyCrewSchedule"
import GendecPage from  "@/views/Dai_Gendec/GendecPage"
import GendecAirportManagementPage from  "@/views/Dai_Gendec/GendecAirportManagement"
import DailyLastRevisions from "@/views/Dai_Gendec/DailyLastRevisions";
import GendecRules from "@/views/Dai_Gendec/GendecRules";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: DashboardPage
  },

  //HR
  {
    path: '/HR/hrpersonel',
    name: 'HRPersonelManagement',
    component: HrPage
  },
  {
    path: '/HR/hrpersonelpassport',
    name: 'HRPersonelPassportReport',
    component: HrPassport
  },

  //Daily gendec
  {
    path: '/DAI-Gendec/daily-crew-schedule',
    name: 'daily-crew-schedule',
    component: DailyCrewSchedulePage
  },

  {
    path: '/DAI-Gendec/gendec',
    name: 'gendec',
    component: GendecPage
  },

  {
    path: '/DAI-Gendec/gendec-management',
    name: 'gendec-management',
    component: GendecAirportManagementPage
  },

  {
    path: '/DAI-Gendec/last-revisions',
    name: 'last-revisions',
    component: DailyLastRevisions
  },

  {
    path: '/DAI-Gendec/gendec-rules',
    name: 'gendec-rules',
    component: GendecRules
  },



  {path: '*', component: NotFoundPage}
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
